// Handling login APIs

jQuery(function ($) {
  if (!$("body.path-search").length > 0) {
    return;
  }

  console.log("search.js");

  const filterHeadings = $(".block-facet--checkbox h2");

  // Collapse/Expand filters
  filterHeadings.on("click", function () {
    const thisElm = $(this);

    thisElm.toggleClass("active");
    thisElm.next().toggleClass("active");
  });

  $(
    '<div class="text-mobileM md:text-desktopM font-bold mb-4">Filter results by</div>'
  ).insertBefore($(".block-facet--checkbox").first());

  $(".view-filters").insertBefore($(".view-filters").first().parent());

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const entries = urlParams.entries();
  // console.log({entries});
  const entriesArray = [];

  let tags = [];

  for (const entry of entries) {
    // console.log("entry", entry);

    let value = "";

    if (entry[1] !== "" && entry[0] !== "page") {
      if (entry[0] === "search_api_fulltext") {
        value = entry[1];
      } else if (entry[0] !== 'recaptcha_token') {
        value = entry[1].split(":")[1].trim();
      }

      if (entry[0] !== 'recaptcha_token') {
        tags.push(String(value));
        entriesArray.push(entry);
      }
    }
  }

  // console.log("entriesArray", entriesArray);

  if (tags.length > 0) {
    $(".view-filters")
      .first()
      .append(
        '<div id="filter-tags" class="filter-tags-wrapper flex flex-wrap mb-8"></div>'
      );

    $.each(tags, function (index, value) {
      $("#filter-tags").append(
        '<button class="filter-tag search-filter-tag capitalize" data-index="' +
          index +
          '">' +
          (value === 'event_calendar' ? 'Events' : value) +
          "</button>"
      );
    });
  } else {
    // $(".view-filters").first().append('<div class="pb-8"></div>');
  }

  // Tag's click handler, to remove the tag and reconstruct url params
  $(".search-filter-tag").on("click", function () {
    const index = $(this).data("index");

    entriesArray.splice(index, 1);

    let urlParams = "";

    $.each(entriesArray, function (index, value) {
      let and = "";

      if (index > 0) {
        and = "&";
      }

      urlParams +=
        and + encodeURIComponent(value[0]) + "=" + encodeURIComponent(value[1]);
    });

    let newURL = window.location.href.split("?")[0];

    if (urlParams !== "") {
      newURL += "?";
    }

    newURL += urlParams;

    window.location = newURL;
  });

  const searchForm = $(".form-item-search-api-fulltext");
  if (searchForm.length > 0) {
    searchForm
      .find('input[name="search_api_fulltext"]')
      .addClass("search w-full big-searchbox");
    searchForm.append(
      '<p class="text-desktopXS mt-2 !mb-0 opacity-50">Press enter to search</p>'
    );
    searchForm
      .parents(".views-exposed-form")
      .detach()
      .insertAfter(".search-page-title");
  }

  $(".view-search .views-row").each(function () {
    const eachRow = $(this);

    // START date field UI manipulation //////////////////////////////////////////
    // iterate through dates of each result row that is not created date field
    // if empty, remove all the field elements
    const eachRowDates = eachRow.find(
      ".tema-views-result-date:not(.views-field-created)"
    );
    eachRowDates.filter((idx) => {
      const dateField = $(eachRowDates[idx]);
      const textContent = dateField.find(".field-content").text().trim();
      const isEmpty = textContent.length > 0 ? false : true;
      if (isEmpty) {
        dateField.remove();
      }
    });

    // check for remaining non empty date fields and remove every field except the first
    eachRow.find(".tema-views-result-date").map(function (idx) {
      if (idx > 0) {
        const dateField = $(this);
        dateField.remove();
      }
    });
    // END date field UI manipulation //////////////////////////////////////////

    // START content type + tags field UI manipulation //////////////////////////////////////////
    const resultTags = [];

    const typeFieldTextNodes = eachRow
      .find(".tema-views-result-type .field-content")
      .contents()
      .filter(function () {
        return this.nodeType === 3; // filter out non-text nodes
      });
    const resultContentType = typeFieldTextNodes.text().trim();

    if (resultContentType) {
      resultTags.push("<li>" + resultContentType + "</li>");
    }

    // disable entity field rendering on Tags field in the Views settings
    // so that the following HTML structure matches with rendered content
    eachRow.find(".tema-views-result-tags .field-content li").each(function () {
      const tagItem = $(this);
      resultTags.push("<li>" + tagItem.text() + "</li>");
    });

    if (resultTags.length > 0) {
      let tagsHTML = '<div class="tema-views-result-grouped-type-tags">';
      tagsHTML += "<ul>";
      tagsHTML += resultTags.join("");
      tagsHTML += "</ul>";
      tagsHTML += "</div>";

      eachRow.find(".tema-views-result-type").remove();
      eachRow.find(".tema-views-result-tags").remove();
      eachRow.append(tagsHTML);
    }
    // END content type + tags field UI manipulation //////////////////////////////////////////

    // START remove empty body field //////////////////////////////////////////
    const bodyField = eachRow.find(".tema-views-result-summary");
    const bodyFieldContent = bodyField.find(".field-content").text().trim();
    bodyFieldContent.length > 0 ? false : bodyField.remove();
    // END remove empty body field //////////////////////////////////////////
  });
});
